// Red tint + shake on a unit when it takes damage. Drives UnitVisual fields.

import type { Animation } from "../../engine/animation/AnimationQueue";
import { TIMING } from "../../config/constants";
import type { UnitVisual } from "../UnitVisual";

export class HitFlashVFX implements Animation {
  private elapsed = 0;
  private duration = TIMING.hitFlash;

  constructor(private visual: UnitVisual) {}

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, this.duration);
    const p = this.elapsed / this.duration;
    // Flash intensity peaks immediately and fades.
    this.visual.hitFlash = Math.max(0, 1 - p);
    // Small horizontal shake.
    this.visual.shakeX = Math.sin(p * Math.PI * 8) * (1 - p) * 4;
  }

  isDone(): boolean {
    return this.elapsed >= this.duration;
  }

  onEnd(): void {
    this.visual.hitFlash = 0;
    this.visual.shakeX = 0;
  }
}
